export default __webpack_public_path__ + "static/media/diamond-circle-dark.9594bcf6.svg";